export const createConversionId = (): string => {
  const conversionId: string =
    Date.now().toString(36) +
    window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36);
  return conversionId;
};
